var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome2L({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 846,
    height: 391,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#C1F9A2",
    d: "M25.515 184.273c5.774.952 14.134 2.121 13.66 8.009-.387 4.588-6.248 5.974-10.773 6.666-9.61 1.472-19.435 5.585-24.821 13.723-5.387 8.139-4.482 20.823 3.749 26.018 4.568 2.857 10.213 3.03 15.6 3.117 5.386.086 11.031.303 15.556 3.203 4.525 2.944 7.067 9.61 3.749 13.896-2.586 3.333-7.326 3.81-11.506 4.243-6.938.692-13.962 2.034-19.909 5.671-5.947 3.636-10.644 9.87-10.816 16.839-.172 7.836 5.387 14.936 12.195 18.745 6.852 3.81 14.824 4.892 22.58 5.671a390.471 390.471 0 0 0 71.837.52c13.703-1.169 28.958-4.026 36.887-15.325 8.662-12.338 4.094-30.909-7.584-40.433-11.678-9.524-28.312-10.996-42.835-7.143-3.706.996-7.498 2.294-11.247 1.602-3.749-.65-7.369-4.243-6.464-7.966 1.207-4.978 8.016-5.281 13.1-4.718 11.937 1.298 24.779 1.039 34.992-5.368 10.213-6.407 16.246-20.65 10.256-31.083-5.861-10.173-19.349-12.294-31.027-13.29a15180.47 15180.47 0 0 0-42.102-3.593c32.148-8.268 41.413-43.42 13.36-53.03-18.66-6.364-39.517-6.364-54.944 5.454-17.28 13.247-20.943 44.07 6.507 48.572Z",
    style: {
      fill: "#c1e4d1",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EFF3EE",
    rx: 31.776,
    ry: 28.342,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "matrix(.83827 .54764 .5418 -.8313 307.997 241.763)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#97dbcb",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C7F5EA",
    d: "M332.049 151.468c6.222-10.951 15.46-19.112 18.372-20.832 41.388-24.455 23.837 35.085-8.409 43.769-22.704 6.114-18.881-7.244-9.963-22.937Z",
    style: {
      fill: "#97dbcb",
      fillOpacity: 1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 5,
    d: "M239 217.506c15-31.506 60.5-42.467 102-11 55.113 41.789 78-13.054 54-20.506-28.247-8.771-19.5 89 84.5 113.006"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#518d64",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#29AB87",
    rx: 47.548,
    ry: 55.241,
    style: {
      fill: "#518d64",
      fillOpacity: 1
    },
    transform: "matrix(.93425 -.35742 -.35777 -.9335 166.089 318.689)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 5,
    d: "m162.408 249.206 41.36 51.357-15.823 7.151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeWidth: 5,
    d: "M187.655 280.894C185.5 256 210.448 264.67 210.448 264.67M152.962 295.562c-3.5-16.5 18-22 26-13M207.763 310.197c-13.958 14.114-31.643 7.995-38.272 2.144"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      stroke: "#e6abab",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M222.593 210.984c.729.408 2.124.962 3.53.164 1.268-.72 1.565-2.024 1.655-2.524.115-.637.108-1.291.094-1.731-.009-.306-.02-.493-.027-.636-.008-.142-.014-.241-.014-.37 0-1.692-.053-3.455-.106-5.21l-.028-.939c-.061-2.082-.109-4.156-.066-6.205.087-4.121.543-7.956 1.888-11.263 1.338-3.291 4.52-5.241 8.368-5.679 3.882-.442 7.934.737 10.452 3.122 5.785 5.476 9.542 13.469 11.196 22.196 1.653 8.718 1.166 17.967-1.322 25.771-2.497 7.828-6.906 13.93-12.878 16.861-5.846 2.869-13.744 2.966-23.916-2.289-5.423-4.06-9.682-9.162-12.575-14.28-2.94-5.2-4.377-10.249-4.343-14.103.034-3.842 1.444-5.906 3.609-6.637 2.522-.852 7.136-.356 14.483 3.752Z",
    style: {
      stroke: "#e6abab",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#bfa1d6",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#D096FE",
    rx: 24.15,
    ry: 27.023,
    style: {
      fill: "#bfa1d6",
      fillOpacity: 1
    },
    transform: "matrix(-.83787 -.5464 .54658 -.83707 489.005 306.815)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#77c69b",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#54E596",
    d: "M575.614 176.799c-12.223 13.438-16.195 35.739-22.629 52.158-5.406 13.794-.859-28.328-8.287-41.403-23.75-41.811-43.141 210.496 59.783 109.027 24.393-24.048 41.519-72.83 26.367-85.871-18.848-16.223-52.343 56.669-36.957 17.563 9.359-23.786 9.489-82-18.277-51.474Z",
    style: {
      fill: "#77c69b",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      fill: "#fae89a",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7B568",
    d: "M618.882 72.155 755.107.972l89.998 108.075-201.593 90.666-24.63-127.558Z",
    style: {
      fill: "#fae89a",
      fillOpacity: 1
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 5,
    d: "M583.859 370.252c11.718-12.997-15.914-14.499-11.706-26.361 4.916-13.858 34.928 3.537 39.824-4.997 4.84-8.437-15.118-16.649-25.078-19.764-11.749-3.675-17.482-7.482-16.859-11.987 1.268-8.502 21.167-.148 43.993 5.92 25.496 6.776 28.967-15.563 7.944-30.138-21.023-14.574-46.977-18.08-46.977-18.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome2L);
export default __webpack_public_path__ + "static/media/bg_home2_l.70aef9c5d81d36ce8459f2e069f2368c.svg";
export { ForwardRef as ReactComponent };